import React, { Component } from 'react'
import { Modal } from 'advenio-components'
import PropTypes from 'prop-types'
import Activity from '../Activity'

class ModalContainer extends Component {
  state = {
    width: 0,
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => this.setState({ width: window.innerWidth })

  render() {
    const { categories, child, children, closeModal, isOpen, isIncidentActivity, loading,
      postActivity, postFinishActivity, activeClassroom } = this.props

    return (
      <Modal
        isOpened={isOpen}
        full={this.state.width < 763}
        onClose={closeModal}
        statePath="activity"
        actionType="sending"
        typePrefix="ACTIVITY"
      >
        <Activity
          loading={loading}
          child={child}
          children={children}
          closeModal={closeModal}
          isIncidentActivity={isIncidentActivity}
          categories={categories}
          postActivity={postActivity}
          postFinishActivity={postFinishActivity}
          activeClassroom={activeClassroom}
        />
      </Modal>
    )
  }
}

ModalContainer.propTypes = {
  /** The listing of available activities that can be registered */
  categories: PropTypes.array,
  /** The child to whom the activity is being registered */
  child: PropTypes.object,
  /** For Group Activity only: The children to whom the activity is being registered */
  children: PropTypes.array,
  /** Flag marking if the modal should be displayed */
  isOpen: PropTypes.bool,
  /** Flag marking if a report activity is to be registered */
  isIncidentActivity: PropTypes.bool,
  /** Loading flag */
  loading: PropTypes.bool,

  /** Callback function to be fired after closing the modal */
  closeModal: PropTypes.func.isRequired,
  /** Callback function to be fired to submit the activity to the API */
  postActivity: PropTypes.func.isRequired,
  /** Callback function to be fired to mark the activity as completed in the API */
  postFinishActivity: PropTypes.func.isRequired,
}

ModalContainer.defaultProps = {
  categories: [],
  child: {},
  children: [],
  isOpen: false,
  isIncidentActivity: false,
  loading: false,
}

export default ModalContainer



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/index.jsx